import React from "react";
import StoreProducts from "../../components/User/StoreProducts";

export default function StoreProductsPage() {
  return <StoreProducts />;
}